import { Component, AfterViewInit } from '@angular/core';

@Component({
  selector: 'contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements AfterViewInit {

  constructor() { }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

}



// WEBPACK FOOTER //
// ./src/app/static/contact/contact.component.ts